if (window.jQuery) {
	window.jQuery(document).on('frmFormComplete', function (event: Event, formEl: HTMLElement) {
		if (window.dataLayer) {
			window.dataLayer.push({
				event: 'formidable-form-success',
				'frm-form-id': formEl.id,
			});
		}
	});
}
